import React from 'react';
import { Badge } from '@dev-go4ellis/go4-design-system';
import './HowItWorks.scss';

const STEPS = [
  { num: '01', title: 'Estimate', body: 'Run the numbers with the calculator above. No account needed.' },
  { num: '02', title: 'Post', body: 'Create a free account and post the shift in minutes.' },
  { num: '03', title: 'Confirm', body: 'Trainers in your area apply. Pick who fits and confirm.' },
  { num: '04', title: 'Cover', body: 'Trainer works the shift. You pay only for hours worked, plus the flat fee.' },
];

const HowItWorks = () => (
  <section className="pl-how">
    <div className="pl-how__inner">
      <div className="pl-how__badge">
        <Badge variant="soft" color="info" size="sm">HOW IT WORKS</Badge>
      </div>

      <h2 className="pl-how__title">From estimate to covered event in four steps</h2>

      <div className="pl-how__grid">
        {STEPS.map((step) => (
          <div key={step.num} className="pl-how__step">
            <div className="pl-how__num">{step.num}</div>
            <div className="pl-how__step-title">{step.title}</div>
            <div className="pl-how__step-body">{step.body}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
